import React from 'react';
import { Button } from 'react-bootstrap';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { format, addMonths, subMonths } from 'date-fns';

export function MonthYearSelector({ currentDate, onMonthChange }) {
    return (
        <div className="d-flex align-items-center justify-content-between mb-3">
            <Button
                variant="light"
                onClick={() => onMonthChange(subMonths(currentDate, 1))}
            >
                <ChevronLeft size={20} />
            </Button>

            <h2 className="h4 mb-0">
                {format(currentDate, 'MMMM yyyy')}
            </h2>

            <Button
                variant="light"
                onClick={() => onMonthChange(addMonths(currentDate, 1))}
            >
                <ChevronRight size={20} />
            </Button>
        </div>
    );
}